module.exports = __webpack_public_path__ + "img/17@2x.179b8557.png";